export enum DocumentsSections {
    USER_AGREEMENT = "USER_AGREEMENT",
    PAYMENT_SECURITY_POLICY = "PAYMENT_SECURITY_POLICY",
    COOKIE_POLICY = "COOKIE_POLICY",
    PRIVACY_POLICY = "PRIVACY_POLICY",
    COMPLAINT_AND_DISPUTE_RESOLUTION_POLICY = "COMPLAINT_AND_DISPUTE_RESOLUTION_POLICY",
    SUBSCRIPTION_POLICY = "SUBSCRIPTION_POLICY",
    POSTING_RULES = "POSTING_RULES",
    PUBLIC_OFFER = "PUBLIC_OFFER",
}
